/** Minimum reconnect/drop events (either layer) in the rolling window to mark unstable. */
export const CONNECTION_HEALTH_FLAP_THRESHOLD = 3;

/** Rolling window for counting reconnect/drop events. */
export const CONNECTION_HEALTH_FLAP_WINDOW_MS = 60_000;

/** Layer continuously down this long triggers unstable (while recovering). */
export const CONNECTION_HEALTH_LAYER_DOWN_MS = 5_000;

/** Quiet period with no further drops before clearing unstable. */
export const CONNECTION_HEALTH_UNSTABLE_CLEAR_MS = 20_000;

/**
 * After going online, ignore flap/down-unstable signals until both layers have
 * connected at least once, or this grace elapses — avoids false "unstable" on
 * normal SIP + socket startup (common for admins who start offline).
 */
export const CONNECTION_HEALTH_SESSION_WARMUP_MS = 45_000;

/** Tick interval for layer-down timers and unstable clear checks. */
export const CONNECTION_HEALTH_TICK_MS = 1_000;
